export const SUCCESS_DYNAMIC_COVER_FIELDS = "SUCCESS_DYNAMIC_COVER_FIELDS";
export const LOADING_DYNAMIC_COVER_FIELDS = "LOADING_DYNAMIC_COVER_FIELDS";
